import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Link",
        "Label": "new-building",
        "Color": "accent",
        "Icon": "add",
        "Link": ['/','buildings','new']
    },
]